// Vinci payment rail helper — PhonePe primary (hosted redirect), Razorpay fallback (inline checkout).
export function loadRazorpay() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

// Returns true when the response was a PhonePe redirect (the browser is leaving the page).
export function redirectIfPhonePe(data) {
  if (data?.provider === "phonepe" && data.redirect_url) {
    try { sessionStorage.setItem("vinci.pay.intent", data.intent_id); } catch { /* ignore */ }
    window.location.assign(data.redirect_url);
    return true;
  }
  return false;
}

// Generic rail launcher used by the hosted pay page: customer's explicit rail → PhonePe redirect or Razorpay checkout verified via the intent.
export async function launchIntentCheckout(api, intentId, { rail, name, description, prefill, onSuccess, onDismiss } = {}) {
  const { data } = await api.post(`/payments/intents/${intentId}/checkout${rail ? `?rail=${rail}` : ""}`);
  if (redirectIfPhonePe(data)) return data;
  const ok = await loadRazorpay();
  if (!ok) throw new Error("Could not load the payment gateway. Please retry.");
  const rz = new window.Razorpay({
    key: data.key_id, amount: data.amount_paise, currency: data.currency, order_id: data.order_id,
    name: name || "Vinci Inc.", description: description || "", prefill: prefill || {}, theme: { color: "#C9A84C" },
    handler: async (rp) => {
      const r = await api.post(`/payments/intents/${intentId}/razorpay-verify`, {
        razorpay_order_id: rp.razorpay_order_id, razorpay_payment_id: rp.razorpay_payment_id, razorpay_signature: rp.razorpay_signature,
      });
      onSuccess && onSuccess(r.data.intent);
    },
    modal: { ondismiss: () => onDismiss && onDismiss() },
  });
  rz.open();
  return data;
}

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
